import { render } from "./WatchFullVideoButton.vue?vue&type=template&id=6934e044&scoped=true"
import script from "./WatchFullVideoButton.vue?vue&type=script&lang=ts"
export * from "./WatchFullVideoButton.vue?vue&type=script&lang=ts"

import "./WatchFullVideoButton.vue?vue&type=style&index=0&id=6934e044&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6934e044"

export default script